import script from "./HomeStatsQuery.vue?vue&type=script&lang=js"
export * from "./HomeStatsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__